'use strict';

var _ = require('lodash');
var ToolbarNextPreviousButtonService = function ToolbarNextPreviousButtonService(momentService, $filter) {
  var config = require('../constants/NextPreviousButton.json');
  function getLeftToolTip(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].previousKeyToolTip;
  }
  function getRightToolTip(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].nextKeyToolTip;
  }
  function getRowKeyId(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].rowKeyId;
  }
  function getDefaultGridTitle(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].defaultGridTitle;
  }
  function getMultipleRowGridTitle(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].multipleRowGridTitle;
  }
  function getTitleFormat(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].gridTitleFormat;
  }
  function getTitleArgs(gridId) {
    return config.buttonConfig[gridId] && config.buttonConfig[gridId].gridTitleArgs;
  }
  function constructGridTitle(selectedGrid, selectedRow, rmMomentFormat, selectedRowIndexes, gridData) {
    var gridTitle = selectedGrid.gridTitleFormat;
    var gridTitleArgs = selectedGrid.gridTitleArgs;
    _.forEach(gridTitleArgs, function (arg, i) {
      switch (arg) {
        case 'carrier':
          gridTitle = _.replace(gridTitle, '\$' + i, gridData[selectedRowIndexes[0]].carrier);
          break;
        case 'departureDateMoment':
        case 'flightDepartureDateMoment':
          if (!momentService.isMoment(selectedRow[arg])) {
            selectedRow[arg] = momentService.of(selectedRow[arg], momentService.FIELD.DEPARTURE_DATE);
          }
          gridTitle = _.replace(gridTitle, '\$' + i, rmMomentFormat(selectedRow[arg], 'DATE_USER_SETTINGS'));
          break;
        default:
          gridTitle = _.replace(gridTitle, '\$' + i, selectedRow[arg]);
      }
    });
    return gridTitle;
  }
  function getGridTitle(gridId, gridData, selectionFilters, selectedRowIndexes) {
    var rmMomentFormat = $filter('rmMomentFormat');
    var selectedGrid = config.buttonConfig[gridId];
    if (selectionFilters && selectionFilters.length > 0) {
      if (isMultipleFilterKeysSelected(selectionFilters, selectedGrid.gridTitleArgs)) {
        //Multiple Keys selected
        return selectedGrid.defaultGridTitle + ': ' + selectedGrid.multipleRowGridTitle;
      } else {
        var firstSelectionFilter = selectionFilters[0]; //Take the first row for title computation from multiple rows of same key
        return constructGridTitle(selectedGrid, firstSelectionFilter, rmMomentFormat, selectedRowIndexes, gridData);
      }
    } else {
      return selectedGrid.defaultGridTitle + (selectedGrid.appendListAfterTitle === false ? '' : ' List');
    }
  }
  function isMultipleFilterKeysSelected(selectionFilters, keys) {
    var multipleKeySelected = false;
    if (selectionFilters.length > 0) {
      _.forEach(keys, function (key) {
        var minSelectedRow = selectionFilters[0];
        var maxSelectedRow = selectionFilters[selectionFilters.length - 1];
        if (minSelectedRow[key] !== maxSelectedRow[key]) {
          multipleKeySelected = true;
        }
      });
    }
    return multipleKeySelected;
  }
  function getAllAllowedGridIds() {
    return _.keys(config.buttonConfig).sort();
  }
  return {
    getLeftToolTip: getLeftToolTip,
    getRightToolTip: getRightToolTip,
    getRowKeyId: getRowKeyId,
    getGridTitle: getGridTitle,
    getDefaultGridTitle: getDefaultGridTitle,
    getAllAllowedGridIds: getAllAllowedGridIds,
    getMultipleRowGridTitle: getMultipleRowGridTitle,
    getTitleFormat: getTitleFormat,
    getTitleArgs: getTitleArgs
  };
};
ToolbarNextPreviousButtonService.$inject = ['MomentService', '$filter'];
module.exports = ToolbarNextPreviousButtonService;